let cookieDomain = 'leankeep.com';

if (import.meta.env.DEV) {
  cookieDomain = 'localhost';
  // pending: see why process.env.NODE_ENV returns production in homolog
} else if (window.location.href.indexOf('lkp.dev.br') > -1) {
  cookieDomain = 'lkp.dev.br';
}

export const URLS = {
  movidesk: 'https://leankeep.movidesk.com/kb',
  tickets: 'https://leankeep.movidesk.com/',
  account: `${import.meta.env.VITE_LEGADO}/Cobrancas/ShowCobrancasUsuarioPage.aspx`,
  occurrencesPanel: `${import.meta.env.VITE_LEGADO}/Anomalias/ShowAnomaliasTablePage.aspx`,
  imageDevelopment: 'https://static.lkp.dev.br/logos/https://media.lkp.dev.br/v1/static',
  imageProduction:
    'https://static.lkp.app.br/cdn-cgi/image/fit=pad,w=56,h=56,background=%23FFFFFF,quality=99/https:/media.lkp.app.br/v1/static',
  cookieDomain,
  oldReports: `${import.meta.env.VITE_LEGADO}/Relatorios/ShowRelatoriosMenuPage.aspx`,
  oldDashboard: `${import.meta.env.VITE_LEGADO}/Dashboards/ShowDashboardsPage.aspx`,
  // TODO: confirmar a URL oficial dos Termos de Uso com o time de produto.
  termsOfUse: 'https://www.leankeep.com/termos-de-uso',
};
